import { ReactNode } from "react";
import styles from "./ResultSection.module.scss";

export default function SectionHeader({ children }: { children: ReactNode }) {
  return <div className={styles.section}>{children}</div>;
}
